import { AuthViewModel } from "../viewmodels/AuthViewModel.js";
import { useSingleton } from "mvc-kit/react";
// src/modules/AuthWrapper2/hooks/useCurrentUser.ts
function useCurrentUser() {
	return useSingleton(AuthViewModel).state.identityInfo.user;
}
export { useCurrentUser };

//# sourceMappingURL=useCurrentUser.js.map